// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1WKzg","productName":"Table_productName__1dVtC"};